/**
 * @generated SignedSource<<6c7a2c91fd3af8009d8d8dbfb7e8c69e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SeriesExplorer_note$data = {
  readonly id: string;
  readonly previousNote: {
    readonly createdAt: string | null;
    readonly event: {
      readonly isAllDay: boolean;
    } | null;
    readonly eventStart: string | null;
    readonly id: string;
    readonly url: string | null;
  } | null;
  readonly stream: {
    readonly id: string;
    readonly nextEvent: {
      readonly end: string | null;
      readonly guid: string;
      readonly isAllDay: boolean;
      readonly note: {
        readonly createdAt: string | null;
        readonly event: {
          readonly isAllDay: boolean;
        } | null;
        readonly eventStart: string | null;
        readonly id: string;
        readonly url: string | null;
      } | null;
      readonly start: string | null;
    } | null;
  };
  readonly " $fragmentType": "SeriesExplorer_note";
};
export type SeriesExplorer_note$key = {
  readonly " $data"?: SeriesExplorer_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"SeriesExplorer_note">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAllDay",
  "storageKey": null
},
v2 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "eventStart",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Event",
    "kind": "LinkedField",
    "name": "event",
    "plural": false,
    "selections": [
      (v1/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SeriesExplorer_note",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStream",
      "kind": "LinkedField",
      "name": "stream",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "onlyEmpty",
              "value": false
            }
          ],
          "concreteType": "Event",
          "kind": "LinkedField",
          "name": "nextEvent",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "guid",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "start",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "end",
              "storageKey": null
            },
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Note",
              "kind": "LinkedField",
              "name": "note",
              "plural": false,
              "selections": (v2/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": "nextEvent(onlyEmpty:false)"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Note",
      "kind": "LinkedField",
      "name": "previousNote",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};
})();

(node as any).hash = "bf81a810ed17b88df5d77c186d6004ed";

export default node;
